<template>
  <div>
    <svg t="1492500959545" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.52 30.19" @click="toggleClick" class="hamburger" :class="{'is-active':isActive}"
    version="1.1" p-id="1691" xmlns:xlink="http://www.w3.org/1999/xlink" width="64" height="64">
        <path class="cls-1" d="M25.85,14.23l6.89-4.66a.5.5,0,0,1,.78.42V19.3a.5.5,0,0,1-.78.41l-6.89-4.65A.5.5,0,0,1,25.85,14.23Zm8.67,15a1,1,0,0,0-1-1H1a1,1,0,0,0,0,2H33.52A1,1,0,0,0,34.52,29.19ZM34.52,1a1,1,0,0,0-1-1H1A1,1,0,0,0,1,2H33.52A1,1,0,0,0,34.52,1ZM22.73,10.4a1,1,0,0,0-1-1H1a1,1,0,0,0,0,2H21.73A1,1,0,0,0,22.73,10.4Zm0,9.4a1,1,0,0,0-1-1H1a1,1,0,0,0,0,2H21.73A1,1,0,0,0,22.73,19.8Z"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
.hamburger {
  fill:#606266;
	display: inline-block;
	cursor: pointer;
	width: 16px;
	height: 16px;
	transform: rotate(180deg);
	transition: 1.38s;
  transform-origin: 50% 50%;
  /* margin-top: 16px; */
  /* margin-right: 10px; */
  margin-left: 10px;
  /* float: right; */

}
.hamburger.is-active {
	transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Hamburger/index.vue